import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigatorService } from '../services/navigator.service';
import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
import { GenericDetailComponent } from '../shared/GenericDetailComponent';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlService } from '../commons/calendar/prevUrl.service';
import { ColloquioConoscitivoService } from '../services/colloquio/colloquio-conoscitivo.service';
import { ColloquioConoscitivoDTO } from '../shared/dto/colloquio/colloquio-conoscitivo';
import { ResponseFail } from '../shared/dto/responseFail';
import { telefonoValidator } from './telefonoValidator.validator';

@Component({
  selector: 'app-colloquio-conoscitivoDetail',
  templateUrl: './colloquio-conoscitivoDetail.component.html',
  styleUrls: ['./colloquio-conoscitivoDetail.component.scss']
})
export class ColloquioConoscitivoDetailComponent extends GenericDetailComponent implements OnInit, OnDestroy {

  colloquioId: number;
  colloquio: ColloquioConoscitivoDTO;
  index: number[];
  today: Date;
  minDate: Date;
  previousUrlService: Observable<string> = this.urlService.previousUrl$;
  previousUrl: string;

  voti = [1,2,3,4,5,6,7,8,9,10];
  votiIstruzione = Array.from({length: 52}, (_, i) => i + 60);
  
  constructor(
    private urlService: UrlService,
    navigatorService: NavigatorService,
    activatedRoute: ActivatedRoute,
    private colloquioConoscitivoService: ColloquioConoscitivoService,
    snackBar: MatSnackBar,
    dialog: MatDialog,
    router: Router,
    timestampFormatPipe: TimestampFormatPipe,
    dateAdapter: DateAdapter<Date>,
    ) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activatedRoute,
      snackBar,
      timestampFormatPipe
    );
    this.form = new FormGroup({
      id: new FormControl({ value: '', disabled: true }),
      dataColloquio: new FormControl('', Validators.required),
      nome: new FormControl('', Validators.required),
      cognome: new FormControl('', Validators.required),
      numTelefono: new FormControl('', [Validators.required, telefonoValidator]),
      email: new FormControl('', [Validators.required, Validators.email]),
      istruzione: new FormControl('', Validators.required),
      votoIstruzione: new FormControl('', Validators.required),
      voto: new FormControl(null, Validators.required),
      votoQuiz: new FormControl('', Validators.required),
      votoSpigliatezza: new FormControl('', Validators.required),
      votoComprensione: new FormControl('', Validators.required),
      votoLogica: new FormControl('', Validators.required),
      descrizione: new FormControl('', Validators.required),
      deleteDate: new FormControl({ value: '', disabled: true }),
      deleteUser: new FormControl({ value: '', disabled: true }),
      insertDate: new FormControl({ value: '', disabled: true }),
      insertUser: new FormControl({ value: '', disabled: true }),
      updateDate: new FormControl({ value: '', disabled: true }),
      updateUser: new FormControl({ value: '', disabled: true }),
      optLock: new FormControl({ value: '', disabled: true }),
    });
    this.minDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate() - 1,
    );
    this.today = new Date();
  }

  ngOnInit() {
    if(!this.isJappTenantAdmin()){
      this.snackBar.open("Non è possibile entrare nella pagina dei colloqui conoscitivi se non si è admin!", null, { duration: 3000 });
      this.router.navigate(["/"]);
    }
    this.colloquioId = Number(this.activeRoute.snapshot.paramMap.get("id"));
    if (this.colloquioId != null && this.colloquioId != 0) {
      this.colloquioRead();
    } else {
      this.colloquioInit();
    }
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;
    });
  }

  colloquioSave() {
    if (this.colloquio.id == null) {
      this.colloquioCreate();
    } else {
      this.colloquioUpdate();
    }
  }

  colloquioCreate() {
    if (this.form.valid) {
      this.formToDto();
      this.colloquioConoscitivoService.create(this.colloquio).subscribe( 
        (res: ColloquioConoscitivoDTO) => {
          console.log("response : " + res);
          this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
          this.colloquio = res;
          this.colloquioId = this.colloquio.id;
          this.dtoToForm();
          this.form.markAsPristine();
        }, (err: HttpErrorResponse) => {
          //403 Forbidden
          //InvalidArgumentException REQUIRED_FIELD_MISSING
          //InvalidCollaboratoreException COLLABORATORE_NOT_FOUND
          if (err.status == 403) {
            this.snackBar.open("Attenzione! Non è possibile creare un nuovo colloquio conoscitivo se non si è admin!", null, { duration: 4500 });
          }
          if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidArgumentException_REQUIRED_FIELD_MISSING") {
            this.snackBar.open("Attenzione! Non sono stati compilati tutti i campi obbligatori", null, { duration: 4500 });
          }
        });
    }
  }

  colloquioUpdate() {
    if (this.form.valid && this.form.dirty) {
      this.confirm("Sei sicuro di voler sovrascrivere il colloquio conoscitivo?").subscribe(result => {
        if (result) {
          this.formToDto();
          this.colloquioConoscitivoService.update(this.colloquio).subscribe(
            (res) => {
              console.log("response : " + res);
              this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
              this.colloquioRead();
              this.form.markAsPristine();
            }, (err: HttpErrorResponse) => {
              // 403 Forbidden
              //InvalidColloquioException REQUIRED_FIELD_MISSING
              if (err.status == 403) {
                this.snackBar.open("Attenzione! Non è possibile aggiornare i colloqui conoscitivi se non si è admin!", null, { duration: 4500 });
              }
              if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidArgumentException_REQUIRED_FIELD_MISSING") {
                this.snackBar.open("Attenzione! Non sono stati compilati tutti i campi obbligatori", null, { duration: 4500 });
              }
            });
        }
      });
    }
  }

  colloquioDelete() {
    if (this.form.valid) {
      this.confirm("Sei sicuro di voler cancellare il colloquio conoscitivo?").subscribe(result => {
        if (result) {
          this.formToDto();
          this.colloquioConoscitivoService.delete(this.colloquio.id).subscribe(
            (res) => {
              console.log("response : " + res);
              this.snackBar.open("Cancellazione avvenuta con successo!", null, { duration: 3000 });
              this.router.navigate(["/colloquio-conoscitivo"]);
            }
          ), (err: HttpErrorResponse) => {
            //403 Forbidden
            //InvalidArgumentException REQUIRED_FIELD_MISSING
            //InvalidColloquioException COLLOQUIO_NOT_FOUND
            if (err.status == 403) {
              this.snackBar.open("Attenzione! Non è possibile cancellare i colloqui conositivi se non si è admin!", null, { duration: 4500 });
            }
            if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidArgumentException_REQUIRED_FIELD_MISSING") {
              this.snackBar.open("Attenzione! Non sono stati compilati tutti i campi obbligatori", null, { duration: 4500 });
            }
            if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidColloquioException_COLLOQUIO_NOT_FOUND") {
              this.snackBar.open("Attenzione! Il colloquio scelto non è stato trovato!", null, { duration: 4500 });
            }
          };
        }
      });
    }
  }

  colloquioRead() {
    this.colloquioConoscitivoService.read(this.colloquioId).subscribe(
      (res: ColloquioConoscitivoDTO) => {
        console.log("response : " + res);
        this.colloquio = res;
        this.colloquioId = res.id;
        this.dtoToForm();
      }
    ), (err: HttpErrorResponse) => {
      //InvalidColloquioException COLLOQUIO_WRONG_ROLE
      //InvalidArgumentException REQUIRED_FIELD_MISSING
      //InvalidColloquioException COLLOQUIO_NOT_FOUND
      if (err.status == 403) {
        this.snackBar.open("Attenzione! Non è possibile richiedere le informazioni sui colloqui conoscitivi se non si è admin!", null, { duration: 4500 });
      }
      if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidArgumentException_REQUIRED_FIELD_MISSING") {
        this.snackBar.open("Attenzione! Non sono stati compilati tutti i campi obbligatori", null, { duration: 4500 });
      }
      if (err.status == 400 && (<ResponseFail>err.error).reasonBundleKey == "InvalidColloquioException_COLLOQUIO_NOT_FOUND") {
        this.snackBar.open("Attenzione! Il colloquio conoscitivo scelto non è stato trovato!", null, { duration: 4500 });
      }  
    };
  }

  colloquioInit() {
    this.colloquio = new ColloquioConoscitivoDTO();
    this.form.get("dataColloquio").setValue(new Date());
  }

  private formToDto(): void {
    this.colloquio.dataColloquio = this.form.get("dataColloquio").value;
    this.colloquio.descrizione = this.form.get("descrizione").value;
    this.colloquio.nome = this.form.get("nome").value;
    this.colloquio.cognome = this.form.get("cognome").value;
    this.colloquio.numTelefono = this.form.get("numTelefono").value;
    this.colloquio.email = this.form.get("email").value;
    this.colloquio.istruzione = this.form.get("istruzione").value;
    this.colloquio.votoIstruzione = this.form.get("votoIstruzione").value;
    this.colloquio.voto = this.form.get("voto").value;
    this.colloquio.votoQuiz = this.form.get("votoQuiz").value;
    this.colloquio.votoSpigliatezza = this.form.get("votoSpigliatezza").value;
    this.colloquio.votoComprensione = this.form.get("votoComprensione").value;
    this.colloquio.votoLogica = this.form.get("votoLogica").value;
  }

  private dtoToForm(): void {
    this.form.get("id").setValue(this.colloquio.id);
    this.form.get("dataColloquio").setValue(this.colloquio.dataColloquio);
    this.form.get("descrizione").setValue(this.colloquio.descrizione);
    this.form.get("nome").setValue(this.colloquio.nome);
    this.form.get("cognome").setValue(this.colloquio.cognome);
    this.form.get("numTelefono").setValue(this.colloquio.numTelefono);
    this.form.get("email").setValue(this.colloquio.email);
    this.form.get("istruzione").setValue(this.colloquio.istruzione);
    this.form.get("votoIstruzione").setValue(this.colloquio.votoIstruzione);
    this.form.get("voto").setValue(this.colloquio.voto);
    this.form.get("votoQuiz").setValue(this.colloquio.votoQuiz);
    this.form.get("votoSpigliatezza").setValue(this.colloquio.votoSpigliatezza);
    this.form.get("votoComprensione").setValue(this.colloquio.votoComprensione);
    this.form.get("votoLogica").setValue(this.colloquio.votoLogica);


    this.form.get("deleteDate").setValue(this.colloquio.deleteDate);
    this.form.get("deleteUser").setValue(this.colloquio.deleteUser);
    this.form.get("insertDate").setValue(this.timestampFormatPipe.transform(this.colloquio.insertDate));
    this.form.get("insertUser").setValue(this.colloquio.insertUser);
    this.form.get("updateDate").setValue(this.timestampFormatPipe.transform(this.colloquio.updateDate));
    this.form.get("updateUser").setValue(this.colloquio.updateUser);
    this.form.get("optLock").setValue(this.colloquio.optLock);
    this.form.markAsPristine();
  }

  ngOnDestroy(): void {
  }

}
